<div class="factures-preparees__container">
	<header class="factures-preparees-header">
		<div class="titre">
			<div class="soustitre">
				<h1>Factures préparées</h1>
				<small>{{facturesCount}} {{facturesCount > 1 ? 'factures préparées':'facture préparée'}} pour {{facturesPriceTotal | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr-FR' }}</small>
			</div>
			<lua-bouton-texte *ngIf="!isMobile" [libelle]="libelleBtnFacSansCV" (click)="facturerSansCV()"></lua-bouton-texte>
			<lua-bouton-icone *ngIf="isMobile" (click)="openPanneauFactureMois()" iconName="menu" mode="outlined"></lua-bouton-icone>
		</div>
		<div class="filters" [ngClass]="{'filters-mobile': isMobile}">
			<lua-recherche 
				[fullWidth]="false" 
				iconeDefault="search" 
				placeHolderText="Nom prénom"
				[secondaryAction]="false"
				[searchText]="searchedValue"
				(onValueChange)="searchInvoicesByTerm($event)">
			</lua-recherche>
			<lua-filtres
				[fullWidth]="false" 
				[selectedFilters]="filterInfirmiersSelected" 
				(click)="openMenuFiltreInfirmier($event)" 
				label="Infirmier"
				[color]="colorFilter">
			</lua-filtres>
		</div>
	</header>
	<section class="factures-preparees-list">
		<lua-alerte 
			*ngIf="invoicesCheckbox" 
			[filled]="false" 
			[fullWidth]="true" 
			type="info"
			[message]="messageAlerteFacSansCV">
		</lua-alerte>
		<lua-alerte 
			*ngIf="errorInvoice && messageAlerteErreurFac" 
			[filled]="true" 
			[fullWidth]="true" 
			type="error"
			[message]="messageAlerteErreurFac">
		</lua-alerte>
		<lua-alerte 
			*ngIf="successInvoice && messageAlerteSuccesFac" 
			[filled]="true" 
			[fullWidth]="true" 
			type="success"
			[message]="messageAlerteSuccesFac">
		</lua-alerte>
		<ng-container *ngIf="filteredInvoices?.length > 0; else noData">
		  <div class="group-invoice-by-letter" *ngFor="let letter of organizedLetters">
			<lua-separateur-groupe [label]="letter"></lua-separateur-groupe>
			<ng-container *ngFor="let item of organizedInvoices[letter]">
				<di-carte-facturation-preparee 
					[invoice]="item" 
					[checked]="isInvoiceChecked(item)" 
					[checkbox]="invoicesCheckbox" 
					[onCheck]="updateCheckedInvoices">
				</di-carte-facturation-preparee>
			</ng-container>
		  </div>
		</ng-container>
		<ng-template #noData>
		  <lua-message-aucune-donnee
			[mainText]="texteAucuneFacture"
			iconName="task"
			[subText]="sousTexteAucuneFacture">
		  </lua-message-aucune-donnee>
		</ng-template>
	</section>
	<di-bandeau-facturation-degradee 
		*ngIf="invoicesCheckbox" 
		[invoicesChecked]="preparedInvoicesChecked" 
		[facturer]="facturerDegradeEnMasse" 
		[selectionner]="checkAllInvoices"
		[toutSelectionner]="preparedInvoicesChecked.length !== filteredInvoices.length">
	</di-bandeau-facturation-degradee>	
</div>
